import { useEffect, useState } from "react";

/**
 * Qiymatni kechiktirib qaytaradi. Qidiruv maydonida har harf uchun
 * so'rov yuborish backendni ham, tarmoqni ham behuda band qiladi.
 */
export function useDebounced<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
